export enum SETUP_STATE_STATUSES {
  CONNECTED = 'connected',
  INCOMPLETE = 'incomplete',
  BROKEN = 'broken',
}
